export enum ARCA_STATUS {
    PENDING_APPROVAL = '0',
    APPROVED = '1',
    REJECTED = '2',
    NOT_AVAILABLE = 'N',
}